import { render, staticRenderFns } from "./Member.vue?vue&type=template&id=56c7c110&scoped=true&"
import script from "./Member.vue?vue&type=script&lang=js&"
export * from "./Member.vue?vue&type=script&lang=js&"
import style0 from "./Member.vue?vue&type=style&index=0&id=56c7c110&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c7c110",
  null
  
)

export default component.exports